import React from 'react'

const Files = () => {
  return (
    <div>Files</div>
  )
}

export default Files